import { useCallback } from 'react'
import { getMe, login as apiLogin, register as apiRegister } from '../api/auth'
import { useAuthStore } from '../store/authStore'

export function useAuth() {
  const { token, username, role, credibilityTier, setAuth, clearAuth, isAdmin } = useAuthStore()

  const login = useCallback(
    async (username: string, password: string) => {
      const { access_token } = await apiLogin(username, password)
      const me = await getMe(access_token)
      setAuth(access_token, me.username, me.role, me.credibility_tier)
    },
    [setAuth],
  )

  const register = useCallback(
    async (username: string, email: string, password: string) => {
      await apiRegister(username, email, password)
      await login(username, password)
    },
    [login],
  )

  const logout = useCallback(() => clearAuth(), [clearAuth])

  return {
    token,
    username,
    role,
    credibilityTier,
    isAuthenticated: !!token,
    isAdmin: isAdmin(),
    login,
    register,
    logout,
  }
}
